// import { updateDealRecommendVersion } from "@/services/custom";
import { Form, Select, message } from "antd";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { SFuncModal } from "shj-components";
import {updateDealRecommendVersion} from "@/services/kuAccount.ts";
const { Option } = Select

//添加版本标签
const AddTagDialogMode: React.ForwardRefExoticComponent<React.PropsWithoutRef<{}> & React.RefAttributes<unknown>> = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const _optionList = useRef({ designer: '', customer: '' })

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      try {
        const _designer = JSON.parse(_optionList?.current?.designer);
        const _customer = JSON.parse(_optionList?.current?.customer);
        const _params = {
          casesId: _designer.casesId,
          designerRecommendProHisVerId: _designer.id,
          customerDealProHisVerId: _customer.id,
        };
        if (!_designer.id) {
          _params['designerRecommendProjectsId'] = _designer.projectsId;
        }
        if (!_customer.id) {
          _params['customerDealProjectsId'] = _customer.projectsId;
        }
        updateDealRecommendVersion({ data: _params }).then((resp: any) => {
          message.success('操作成功');
          resolve({})
        }).catch(reject);
      } catch (e) {
        reject({ success: false })
      }
    })
  };
  useImperativeHandle(
    ref,
    () => ({
      form: form,
      onFinish: onFinish
    }),
    [form, onFinish],
  );
  return (
    <Form
      layout="horizontal"
      style={{ padding: '15px' }}
      onFinish={onFinish}
      form={form}
    // ref={formRef}
    >
      <Form.Item
        label="设计师推荐版本"
        name="designer"
        rules={[{ required: true, message: '请选择设计师推荐版本' }]}
      >
        <Select
          placeholder="请选择"
          value="designer"
          onChange={(v) => {
            _optionList.current.designer = v;
          }}
        >
          {props.tagList.map((val: any, index: any) => {
            return (
              <Option
                value={JSON.stringify(val)}
                key={index + val.projectsName ?? '未知' + ' ' + val.versionNumber ?? null}
                data={val.projectsName ?? '未知' + ' ' + val.versionNumber ?? null}
              >
                {val.projectsName ?? '未知' + ' ' + val.versionNumber ?? null}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item label="客户成交版本" name="customer" rules={[{ required: true, message: '请选择设计师推荐版本' }]}>
        <Select
          placeholder="请选择"
          value="customer"
          onChange={(v) => {
            _optionList.current.customer = v;
          }}
        >
          {props.tagList.map((val: any, index: any) => {
            return (
              <Option
                value={JSON.stringify(val)}
                key={index + val.projectsName ?? '未知' + ' ' + val.versionNumber ?? null}
                data={val.projectsName ?? '未知' + ' ' + val.versionNumber ?? null}
              >
                {val.projectsName ?? '未知' + ' ' + val.versionNumber ?? null}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      {/* <Button
          htmlType="submit"
          type="primary"
          onClick={() => {
            tableRef.current.reload();
          }}
        >
          确定
        </Button> */}
    </Form>
  );
})
export function addTagDialog({ fn, tagList, ...rest }: { tagList?: any, fn?: () => void, }) {
  const destroy = () => {
    dialog.destroy();
  };
  const dialog: any = SFuncModal({
    title: `添加版本标签`,
    width: 400,
    vanish: true,
    content: <DioSubmitModelDom fn={fn} onClose={destroy} tagList={tagList} {...rest} />,
  });
}
const DioSubmitModelDom: React.FC<any> = ({ fn, onClose, tagList, ...rest }: { fn: () => void, onClose: () => void, tagList?: any }) => {
  const addRef = useRef(null);
  const [loading, setLoading] = useState(false);
  return <SFuncModal.Content
    cancelText="取消"
    onCancel={() => { onClose?.(); }}
    onOk={() => {
      setLoading(true);
      addRef?.current?.form?.validateFields().then(async res => {
        addRef?.current?.onFinish().then(res => {
          onClose();
          fn && fn();
        }).finally(() => {
          setLoading(false);
        });
      }).catch(() => { setLoading(false); });
    }}
    confirmLoading={loading}
  >
    <AddTagDialogMode onClose={onClose} fn={fn} ref={addRef} tagList={tagList}   {...rest} />
  </SFuncModal.Content>
}
